import { render, staticRenderFns } from "./OpenButton.vue?vue&type=template&id=9b9f3d42"
import script from "./OpenButton.vue?vue&type=script&lang=ts"
export * from "./OpenButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b9f3d42')) {
      api.createRecord('9b9f3d42', component.options)
    } else {
      api.reload('9b9f3d42', component.options)
    }
    module.hot.accept("./OpenButton.vue?vue&type=template&id=9b9f3d42", function () {
      api.rerender('9b9f3d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/OpenButton.vue"
export default component.exports